<div id="preview-controls" style="float: right; margin: 2em;">
  <div class="navigation-button-table">
    <div class="navigation-button-row">
      <div class="navigation-button-col">
        <div>
          <button type="button" [title]="'Drawings.ZoomIn' | i18next" (click)="zoomIn()" class="btn btn-outline-primary btn-sm">
            <i class="fa fa-search-plus action-icon"></i>
          </button>
        </div>
        <div>
          <button type="button" [title]="'Drawings.ZoomOut' | i18next" (click)="zoomOut()" class="btn btn-outline-primary btn-sm">
            <i class="fa fa-search-minus action-icon"></i>
          </button>
        </div>
      </div>
      <div class="navigation-button-col" style="text-align: center">
        <div>
          <button type="button" [title]="'Drawings.MoveUp' | i18next" (click)="moveUp()" class="btn btn-outline-primary btn-sm">
            <i class="fa fa-chevron-up action-icon"></i>
          </button>
        </div>

        <div>
          <button type="button" [title]="'Drawings.MoveLeft' | i18next" (click)="moveLeft()" class="btn btn-outline-primary btn-sm">
            <i class="fa fa-chevron-left action-icon"></i>
          </button>
          <button type="button" [title]="'Drawings.MoveRight' | i18next" (click)="moveRight()" class="btn btn-outline-primary btn-sm">
            <i class="fa fa-chevron-right action-icon"></i>
          </button>
        </div>

        <div>
          <button type="button" [title]="'Drawings.MoveDown' | i18next" (click)="moveDown()" class="btn btn-outline-primary btn-sm">
            <i class="fa fa-chevron-down action-icon"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
